
export const PLATFORM_FEE_COLLECTOR = "0x8302A634B6D67a92DBd28395D407A6DF6cc767D4" as `0x${string}`;

export const erc20Abi = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "name_",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "symbol_",
        "type": "string"
      },
      {
        "internalType": "uint256",
        "name": "initialSupply",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "feeCollector_",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "referrerAddress_",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "platformFeePercentage_",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "referrerFeePercentage_",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      }
    ],
    "name": "allowance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "decimals",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "subtractedValue",
        "type": "uint256"
      }
    ],
    "name": "decreaseAllowance",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "feeCollector",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "feePercentage",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "addedValue",
        "type": "uint256"
      }
    ],
    "name": "increaseAllowance",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "referrerAddress",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "referrerFeePercentage",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "transfer",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  }
] as const;

// Fixed bytecode - properly formatted for contract deployment
export const bytecode = "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";
